(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fh-custom-menu"] && !Shopify.designMode) return;
  try {
    function initializeHoneyMenus() {
    document.querySelectorAll('.fh-custom-menu').forEach(root => {
      if (root.dataset.fhReady) return;
      root.dataset.fhReady = 'true';
      root.addEventListener('click', event => {
        const button = event.target.closest('button[data-fh-toggle]');
        if (!button || !root.contains(button)) return;
        event.preventDefault();
        event.stopPropagation();
        const body = document.getElementById(button.getAttribute('aria-controls'));
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        const family = button.classList.contains('fh-custom-menu__family-toggle');
        const scope = family ? root : button.closest('.fh-custom-menu__family-body');
        scope.querySelectorAll(family ? '.fh-custom-menu__family-toggle' : '.fh-custom-menu__group-toggle').forEach(other => {
          if (other === button) return;
          other.setAttribute('aria-expanded', 'false');
          other.lastElementChild.textContent = '+';
          if (family) other.closest('.fh-custom-menu__family').classList.remove('is-open');
          else document.getElementById(other.getAttribute('aria-controls')).hidden = true;
        });
        button.setAttribute('aria-expanded', String(expanded));
        button.lastElementChild.textContent = expanded ? '−' : '+';
        if (family) button.closest('.fh-custom-menu__family').classList.toggle('is-open', expanded);
        else body.hidden = !expanded;
      }, true);
    });
  }
  initializeHoneyMenus();
  document.addEventListener('shopify:section:load', initializeHoneyMenus);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fh-purchase-policy"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('fh-purchase-review'))customElements.define('fh-purchase-review',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.dialog=this.querySelector('dialog');this.check=this.querySelector('input');this.agree=this.querySelector('[data-agree]');this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>this.dialog.close()));this.check.addEventListener('change',()=>this.agree.disabled=!this.check.checked);this.querySelector('[data-review]').addEventListener('click',()=>this.review(false));this.agree.addEventListener('click',()=>{this.memory=true;try{sessionStorage.setItem(this.dataset.key,'yes')}catch{}this.unlock();this.result=true;this.dialog.close()});this.dialog.addEventListener('close',()=>{this.resolve?.(!!this.result);this.resolve=null;this.opener?.focus()});this.unlock()}
 accepted(){try{return this.memory||sessionStorage.getItem(this.dataset.key)==='yes'}catch{return !!this.memory}}
 unlock(){const express=this.closest('product-form')?.querySelector('[data-fh-express]');if(express)express.hidden=!this.accepted()}
 review(adding=true){if(this.dialog.open)return Promise.resolve(false);this.opener=document.activeElement;this.result=false;this.check.checked=false;this.agree.disabled=true;this.agree.hidden=!adding;this.querySelector('.fh-policy-agree').hidden=!adding;this.dialog.showModal();return new Promise(resolve=>this.resolve=resolve)}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fh-sharing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fh-bee-sharing')) {
    customElements.define('fh-bee-sharing', class extends HTMLElement {
      connectedCallback() {
        if(this.ready) return;
        this.ready=true;
        this.dialog=this.querySelector('dialog');
        this.input=this.querySelector('input');
        this.status=this.querySelector('[role=status]');
        this.images=JSON.parse(this.querySelector('[data-images]')?.textContent || '{}');
        this.button=this.querySelector('[data-open]');
        this.querySelectorAll('[data-app-help]').forEach(button=>button.addEventListener('click',()=>{this.querySelector('[data-app-guide]').hidden=false;if(!this.image){const id=this.gallery?.querySelector('li.is-active[data-media-id]')?.dataset.mediaId.split('-').pop()||Object.keys(this.images)[0];if(id){this.prepare(id);this.querySelector('[data-app-guide]').hidden=false;}}}));
        this.button.addEventListener('click',()=>this.open());
        this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close());
        this.dialog.addEventListener('close',()=>this.opener?.focus());
        this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}});
        this.input.addEventListener('click',()=>this.input.select());
        this.querySelector('[data-copy-message]').addEventListener('click',async()=>{try{await navigator.clipboard.writeText(this.caption);this.status.textContent=this.dataset.copied;}catch{this.input.value=this.caption;this.manual();}});
        this.querySelector('[data-copy-inline]').addEventListener('click',async()=>{try{await navigator.clipboard.writeText(this.url);this.status.textContent=this.dataset.copied;}catch{this.input.value=this.url;this.manual();}});
        this.querySelector('[data-copy]').addEventListener('click',async()=>{try{await navigator.clipboard.writeText(this.url);this.status.textContent=this.dataset.copied;}catch{this.manual();}});
        this.querySelector('[data-messenger]').addEventListener('click',async()=>{this.querySelector('[data-messenger-guide]').hidden=false;try{await navigator.clipboard.writeText(this.caption);this.status.textContent=this.dataset.copied;}catch{this.input.value=this.caption;this.manual();}});
        this.querySelector('[data-native]').hidden=typeof navigator.share!=='function';
        this.querySelector('[data-native]').addEventListener('click',async()=>{if(this.image&&typeof navigator.canShare==='function'){await this.shareFile();return;}try{await navigator.share({title:this.dataset.title,text:this.dataset.intro+'\n'+this.dataset.title,url:this.url});}catch(e){if(e.name!=='AbortError')this.manual();}});
        
        this.querySelector('[data-discord]').addEventListener('click',async()=>{this.querySelector('[data-discord-guide]').hidden=false;try{await navigator.clipboard.writeText(this.caption);this.status.textContent=this.dataset.copied;}catch{this.input.value=this.caption;this.manual();}});
        this.querySelector('[data-ai]').addEventListener('click',()=>{this.querySelector('[data-ai-guide]').hidden=!this.querySelector('[data-ai-guide]').hidden;});
        this.querySelectorAll('[data-ai-open]').forEach(a=>a.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(this.caption);this.status.textContent=this.dataset.copied;}catch{this.input.value=this.caption;this.manual();}}));
        this.querySelector('[data-download]').addEventListener('click',()=>this.download());
        const setup=()=>this.setupGallery();
        if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
        this.prepare();
      }
      manual(){this.status.textContent=this.dataset.manual;this.input.focus();this.input.select();}
      prepare(id) {
        this.image=this.images[id] || null;
        this.mediaId=this.image ? id : null;
        const url=new URL(this.dataset.url);
        if(this.mediaId)url.searchParams.set('fh_image',this.mediaId);
        this.url=url.href;
        this.input.value=this.url;
        const enc=encodeURIComponent;
        this.caption=this.dataset.intro+'\n'+this.dataset.title+'\n'+this.url;
        const message=enc(this.caption);
        const links={threads:'https://www.threads.com/intent/post?text='+message,bluesky:'https://bsky.app/intent/compose?text='+message,reddit:'https://www.reddit.com/submit?url='+enc(this.url)+'&title='+enc(Array.from((this.dataset.intro+' '+this.dataset.title).replace(/\s+/g,' ')).slice(0,300).join('')),snapchat:'https://www.snapchat.com/share?link='+enc(this.url),telegram:'https://t.me/share/url?url='+enc(this.url)+'&text='+enc(this.dataset.intro+'\n'+this.dataset.title),x:'https://x.com/intent/tweet?url='+enc(this.url)+'&text='+enc(this.dataset.intro+'\n'+this.dataset.title),facebook:'https://www.facebook.com/sharer/sharer.php?u='+enc(this.url),pinterest:'https://www.pinterest.com/pin/create/button/?url='+enc(this.url)+'&media='+enc(this.image?.url || this.defaultImage || '')+'&description='+enc(this.dataset.intro+'\n'+this.dataset.title),whatsapp:'https://wa.me/?text='+message,email:'mailto:?subject='+enc(this.dataset.title)+'&body='+message,sms:'sms:'+(/iPad|iPhone|iPod/.test(navigator.userAgent)?'&':'?')+'body='+message};
        this.querySelectorAll('[data-channel]').forEach(a=>{a.href=links[a.dataset.channel];a.hidden=a.dataset.channel==='pinterest'&&!this.image&&!this.defaultImage;});
        const photo=this.querySelector('.fh-share-photo');photo.hidden=!this.image;
        if(this.image){photo.querySelector('img').src=this.image.url;photo.querySelector('img').alt=this.image.alt;}
        
        this.querySelector('[data-download]').hidden=!this.image;
        this.status.textContent='';this.querySelector('[data-app-guide]').hidden=true;this.querySelector('[data-messenger-guide]').hidden=true;this.querySelector('[data-ai-guide]').hidden=true;this.querySelector('[data-discord-guide]').hidden=true;
      }
      open(id,opener=this.button){this.opener=opener;this.prepare(id);this.dialog.showModal();}
      setupGallery(){
        this.root=document.getElementById('MainProduct-'+this.dataset.section);
        this.gallery=this.root?.querySelector('media-gallery');
        this.defaultImage=this.querySelector('[data-default-image]')?.dataset.defaultImage || document.querySelector('meta[property="og:image:secure_url"]')?.content || document.querySelector('meta[property="og:image"]')?.content;
        this.prepare();
        if(!this.gallery)return;
        this.gallery.querySelectorAll('li[data-media-id]').forEach(item=>{
          const id=item.dataset.mediaId.split('-').pop();
          if(!this.images[id]||item.querySelector('.fh-share-overlay'))return;
          item.classList.add('fh-share-media');
          const frame=item.querySelector('.product__modal-opener--image') || item;
          frame.classList.add('fh-share-frame');
          const overlay=document.createElement('div');overlay.className='fh-share-overlay';
          const button=this.button.cloneNode(true);button.removeAttribute('data-open');button.setAttribute('aria-label',this.dataset.overlayLabel);
          button.addEventListener('click',e=>{e.preventDefault();e.stopPropagation();this.open(id,button);});
          overlay.append(button);frame.append(overlay);
        });
        const requested=new URL(location.href).searchParams.get('fh_image');
        if(!this.images[requested])return;
        const select=()=>customElements.whenDefined('media-gallery').then(()=>{
          const item=Array.from(this.gallery.querySelectorAll('li[data-media-id]')).find(x=>x.dataset.mediaId.endsWith('-'+requested));
          if(item){this.gallery.setActiveMedia(item.dataset.mediaId,true);this.gallery.dataset.fhSelectedImage=requested;}
        });
        if(document.readyState==='complete')select();else window.addEventListener('load',select,{once:true});
      }
      async imageFile(){
        const response=await fetch(this.image.url,{credentials:'omit'});if(!response.ok)throw new Error('image');
        const blob=await response.blob();const ext=blob.type.includes('png')?'png':blob.type.includes('webp')?'webp':'jpg';
        return new File([blob],'fashion-honeys-'+this.mediaId+'.'+ext,{type:blob.type});
      }
      async shareFile(){
        try{const file=await this.watermarkedFile();if(!navigator.canShare({files:[file]}))throw new Error('unsupported');await navigator.share({files:[file],title:this.dataset.title,text:this.caption,url:this.url});}
        catch(e){if(e.name!=='AbortError')this.status.textContent=this.dataset.fileFallback;}
      }
      async watermarkedFile(){
        const source=await this.imageFile();
        const sourceUrl=URL.createObjectURL(source);
        try{
          const image=new Image();image.src=sourceUrl;await image.decode();
          const canvas=document.createElement('canvas');
          canvas.width=image.naturalWidth;canvas.height=image.naturalHeight;
          const ctx=canvas.getContext('2d');if(!ctx)throw new Error('canvas');
          ctx.drawImage(image,0,0);
          const scale=Math.min(canvas.width,canvas.height);
          const response=await fetch(this.dataset.watermarkLogo,{credentials:'omit'});if(!response.ok)throw new Error('logo');
          const logoUrl=URL.createObjectURL(await response.blob());
          try{
            const logo=new Image();logo.src=logoUrl;await logo.decode();
            const fit=Math.min(scale*.24/logo.naturalWidth,scale*.24/logo.naturalHeight);
            const width=logo.naturalWidth*fit,height=logo.naturalHeight*fit,margin=scale*.025;
            ctx.save();ctx.globalAlpha=.4;
            ctx.drawImage(logo,canvas.width-width-margin,canvas.height-height-margin,width,height);
            ctx.restore();
          }finally{URL.revokeObjectURL(logoUrl);}
          const blob=await new Promise((resolve,reject)=>canvas.toBlob(b=>b?resolve(b):reject(new Error('export')),'image/png'));
          return new File([blob],'fashion-honeys-'+this.mediaId+'-watermarked.png',{type:'image/png'});
        }finally{URL.revokeObjectURL(sourceUrl);}
      }
      async download(){
        const button=this.querySelector('[data-download]');if(button.disabled)return;button.disabled=true;
        try{const file=await this.watermarkedFile();const blobUrl=URL.createObjectURL(file);const a=document.createElement('a');a.href=blobUrl;a.download=file.name;a.click();setTimeout(()=>URL.revokeObjectURL(blobUrl),30000);this.status.textContent=this.dataset.photoNote;}
        catch{this.status.textContent=this.dataset.fileFallback;}finally{button.disabled=false;}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
